<div class="content">
	<div class="col look">
		<div  class="row scroll-container">
		
		<visitoragreements />
		</div>
	</div>
		<div class="col look">
		<div class="row scroll-container">
		
		<cpolicy />
		</div>
	</div>
	<div class="rightcomponent scroll-container col">
		<div class="" [dir]="currentDirection">
			<div class="row">
				<div class="col">
				
					<registration />
					<authentication />
				</div>
			</div>
		</div>
	</div>
</div>


